module.exports = __webpack_public_path__ + "img/kanban.e9a8d038.png";